const ServiceService = {
    getAll: async function (productId = null) {
        const url = productId !== null
            ? `/api/public/v1/service?productId=${productId}`
            : '/api/public/v1/service';

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            return await response.json();
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    }
};


export default ServiceService;